import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import TreeView from "src/shared/TreeView/TreeView";
import TagTreeHeader from "./TagTreeHeader";

const TreeViewContainer = styled.div`
  max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : "none")};
  overflow-y: ${({ maxHeight }) => (maxHeight ? "auto" : "visible")};
  width: 100%;
  min-width: 0;
`;

const TagsTreeView = ({
  treeData,
  maxHeight,
  onNodeToggled,
  onNodeSelected,
}) => {
  const customizeTreeHeader = () => {
    return TagTreeHeader;
  };

  return (
    <TreeViewContainer maxHeight={maxHeight}>
      <TreeView
        data={treeData}
        onNodeToggled={onNodeToggled}
        onNodeSelected={onNodeSelected}
        customizeTreeHeader={customizeTreeHeader}
        data-testid="tags-hierarchy-tree"
      />
    </TreeViewContainer>
  );
};

TagsTreeView.propTypes = {
  treeData: PropTypes.array.isRequired,
  maxHeight: PropTypes.number,
  onNodeToggled: PropTypes.func,
  onNodeSelected: PropTypes.func,
};

TagsTreeView.defaultProps = {
  maxHeight: 300,
  onNodeToggled: () => {},
  onNodeSelected: () => {},
};

export default TagsTreeView;
